import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { AnySubscriptionType } from '../../../types/misc';
import useActiveSubscription from '../../../hooks/community/useActiveSubscription';
import useSelectedCommunity from '../../../hooks/community/useSelectedCommunity';
import useActiveBusinessSubscription from '../../../hooks/business/useActiveBusinessSubscription';
import useSelectedBusiness from '../../../hooks/business/useSelectedBusiness';
import TrialBanner from '../../components/misc/TrialBanner';
import { SubscriptionSelector } from '../../components/selection-lists/SubscriptionSelector';
import { shouldShowTrialBanner } from '../../../utils/subscriptionUtils';

export function SubscriptionsPage() {
  const { t } = useTranslation('', { keyPrefix: 'page.subscriptions' });
  const communitySubscription = useActiveSubscription();
  const businessSubscription = useActiveBusinessSubscription();
  const navigate = useNavigate();
  const community = useSelectedCommunity();
  const business = useSelectedBusiness();

  const isBusiness = process.env.REACT_APP_APPLICATION_VERSION === 'BUSINESS';
  
  // Use the appropriate subscription and entity based on the app version
  const activeSubscription = isBusiness ? businessSubscription : communitySubscription;
  const entity = isBusiness ? business : community;

  const handleSubscriptionAction = (subscriptionType: AnySubscriptionType) => {
    if (isBusiness) {
      if (activeSubscription === subscriptionType) {
        navigate('/business/subscription');
      } else {
        navigate('/subscription/upgrade', {
          state: { changePaymentMode: false, subscriptionType },
        });
      }
      return;
    }

    if (activeSubscription === subscriptionType) {
      navigate('/subscription/manage');
    } else {
      navigate('/subscription/upgrade', {
        state: { changePaymentMode: false, subscriptionType },
      });
    }
  };

  return (
    <>
      {entity && shouldShowTrialBanner(entity) && (
        <TrialBanner trialEndDate={new Date(entity.trialEndDate!)} plan={entity.trialType!} />
      )}

      <div className="mx-auto max-w-6xl">
        <div className="mb-8 text-center">
          <h1 className="mb-2 text-3xl font-bold text-primary-900">{t('title')}</h1>
          <p className="text-lg text-primary-900 opacity-75">{t('subtitle')}</p>
        </div>

        <SubscriptionSelector
          selectedSubscription={activeSubscription}
          mode="cards"
          showActionButtons
          selectedActionText={t('manageSubscription')}
          unselectedActionText={t('subscribe')}
          onActionClick={handleSubscriptionAction}
          isBusiness={isBusiness}
        />
      </div>
    </>
  );
}
